export default {
  'Submit': 'Submit',
  'Save': 'Save',
  'enterOTP': 'Potwierdź swój numer telefonu',
  'otpSent': 'Jednorazowe hasło wysłane',
  'login/signup': 'Welcome to OYO',
  'resendCode': 'Resend Code',
  'edit': 'Edit',
  'otpMessage': 'Enter the OTP we have sent via SMS to your mobile number',
  'oyo360WelcomeMessage': 'Witamy w OYO',
  'oyo360ResendCode': 'Ponowne przesłanie kodu',
  'oyo360Edit': 'Edytować',
  'oyo360otpMessage': 'Wprowadź kod wysłany przez SMS na swój numer telefonu komórkowego',
  'buttonActionContinue': 'Kontyntynuj',
  'chooseLanguage': 'Wybierz język',
  'currentLanguage': 'OBECNY JĘZYK',
  'otherLanguages': 'INNE JĘZYKI',
  'google': 'Kontynuuj w Google.',
  'facebook': 'Kontynuuj z Facebookiem',
  'or': 'lub',
  'buttonActionSubmit': 'Składać',
  'signingIn': 'Signing In',
  'mobileNumberPlaceholder': 'Wpisz numer telefonu',
  'loginSubText': 'Podaj swój numer telefonu, aby zostać domem wakacyjnym Belvilla w zaledwie 30 minut',
  'welcomeTitle': 'Welcome to OYO',
  'welcomeHeadingForMailLogin': 'Enter the registered email address associated with us',
  'welcomeHeadingForPhoneLogin': 'Enter the registered mobile number associated with us',
  'emailIdLabel': 'Email Id',
  'phoneNumberLabel': 'Phone number',
  'passwordLabel': 'Password',
  'newPasswordLabel': 'New Password',
  'confirmNewPasswordLabel': 'Confirm New Password',
  'emailErrorMessage': 'Please enter the correct email ID',
  'phoneNumberErrorMessage': 'Please enter the correct phone number',
  'passwordErrorMessage': 'Please enter the correct password',
  'confirmPasswordErrorMessage': 'Password is not matched!',
  'generateNewPassword': 'Generate a new password',
  'loginButtonLabel': 'Login',

  'loginWithPhoneButtonLabel': 'Continue with Phone',
  'loginWithOtp': ' Login with OTP instead',
  'loginWithEmailButtonLabel': 'Continue with Email ID',
  'back': 'Back',
  'loginWithOtpTitle': 'Enter verification code',
  'loginWithOtpHeading': 'A 6-digit code was sent to your phone number',

  'listYourProperty': 'List Your Property',
  'listProperty': 'List property',
  'privacyPolicy': ' Privacy policy',
  'termsOfUse': 'Terms of use',
  'privacyFooterText': 'By logging into the account you are agreeing with our {termsOfUse} and {privacyPolicy}',
  'and': 'and',
  'verifyEmail': 'Verify Email Address',
  'verifyMobile': 'Verify Mobile Number',
  'forgotPasswordPhoneSubHeading': 'We will send you a 6-digit code to verify your phone number',
  'forgotPasswordMailSubHeading': 'We will send you a 6-digit code to verify your email ID',
  'newPasswordCondition1': 'Should have both Number & Symbol',
  'newPasswordCondition2': 'Should have atleast 8 characters',
  'newPasswordCondition3': 'Should have both lowercase & uppercase',
  'confirmLogin': 'Confirm & Login',
  'getOTP': 'Get OTP',
  'invalidInput': 'Nieprawidłowe wprowadzanie danych',
  'passwordResetMessage': 'Password generated successfully',
  'otpErrorMessage': 'Please enter correct OTP',
  'resendOtpSuccessMessage': 'OTP has been resend on your mobile number successfully',
  'InternalServerErrorMessage': 'Internal Server Error',
  'resetPasswordHeading': 'A 6-digit code was sent to your email and phone number',
  'whiteSpace': ' ',
  'secureInformation': 'Nie martw się, Twoja informacja jest z nami bezpieczna',
  'termsOfService': 'Warunki usługi',
  'termsOfServiceFooter': 'Wybierając opcję Kontynuuj poniżej, wyrażam zgodę na następujące {termsOfService}',
  'notFoundText': 'We couldn\'t find the page',
  'notFoundDescription': 'Either something went wrong or the page doesn\'t exist anymore',
  'goBackFromNotFoundPage': 'Go Back',
  'goBackToOyoOs': 'Go Back to OYO OS',
  'errorNoAssociatedHotels': 'You have no Hotels associated',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view',
  'mobileSearchPlaceholder': 'Szukaj',
};
